import { render, staticRenderFns } from "./tabDetails.vue?vue&type=template&id=0e2df6c1&scoped=true&"
import script from "./tabDetails.vue?vue&type=script&lang=js&"
export * from "./tabDetails.vue?vue&type=script&lang=js&"
import style0 from "./tabDetails.vue?vue&type=style&index=0&id=0e2df6c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2df6c1",
  null
  
)

export default component.exports